/*
 * Wijn.com bevestiging na toevoegen (snippets/wijncom-toegevoegd.liquid), 12-10-2026, keuze baas: optie 3.
 * - Knop: direct na de klik bolletjes (wc-bezig), na de bevestiging van het thema bruin met vinkje (wc-klaar).
 * - Kaartje: wijn, aantal en prijs uit /cart.js, "nog X tot gratis bezorging". Computer rechtsboven,
 *   telefoon onderin (boven de meeschuivende koopbalk als die in beeld is). Na 5 s weg, pauzeert onder de muis.
 * - Het toevoegen zelf blijft van het thema (instant-add-buttons.js en product-form.js); dit script luistert
 *   alleen mee: submit van een /cart/add-formulier, daarna de gebeurtenissen cart:update en cart:error.
 * - Geen kaartje als de winkelwagenlade open staat (bijvoorbeeld "Frank tipt erbij" in de lade).
 */
(() => {
  if (window.__wijncomToegevoegd) return;
  window.__wijncomToegevoegd = true;

  const sjabloon = document.getElementById('wijncom-toegevoegd');
  const drempel = sjabloon ? parseInt(sjabloon.dataset.drempel, 10) || 7500 : 7500;
  const root = (sjabloon && sjabloon.dataset.root) || '/';
  const ZICHTBAAR_MS = 5000;

  // Shopformaat €{{amount_with_comma_separator}}: €1.234,56
  const euro = (centen) => {
    const [heel, dec] = (Math.max(0, Math.round(centen)) / 100).toFixed(2).split('.');
    return '€' + heel.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec;
  };

  /* ---------- Knop ---------- */

  // Openstaande toevoegingen per variant-id: { knop, flesKnop, timer }
  const bezig = new Map();

  const knopKlaar = (knop) => {
    if (!knop) return;
    knop.classList.remove('wc-bezig');
    knop.classList.add('wc-klaar');
    setTimeout(() => knop.classList.remove('wc-klaar'), 1800);
  };

  const knopTerug = (knop) => {
    if (knop) knop.classList.remove('wc-bezig', 'wc-klaar');
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const actie = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(actie)) return;
      const knop = form.querySelector('button[type="submit"], button[name="add"]');
      if (!knop || knop.disabled) return;
      const id = String(new FormData(form).get('id') || '');
      const tekst = (knop.textContent || '').trim().toLowerCase();
      const vorige = bezig.get(id);
      if (vorige) clearTimeout(vorige.timer);
      knop.classList.remove('wc-klaar');
      knop.classList.add('wc-bezig');
      bezig.set(id, {
        knop,
        flesKnop: /fles|doos/.test(tekst),
        timer: setTimeout(() => { knopTerug(knop); bezig.delete(id); }, 10000),
      });
    },
    true
  );

  document.addEventListener('cart:error', () => {
    bezig.forEach((b) => { clearTimeout(b.timer); knopTerug(b.knop); });
    bezig.clear();
  });

  /* ---------- Kaartje ---------- */

  let kaart = null;
  let verberg = 0;

  const ladeOpen = () => !!document.querySelector('cart-drawer-component dialog[open], .cart-drawer__dialog[open]');

  const sluit = () => {
    clearTimeout(verberg);
    if (kaart) kaart.classList.remove('is-open');
  };

  const plan = (ms) => {
    clearTimeout(verberg);
    verberg = setTimeout(sluit, ms);
  };

  const openWagen = () => {
    sluit();
    const lade = document.querySelector('cart-drawer-component');
    if (lade && typeof lade.open === 'function') lade.open();
    else window.location.href = (sjabloon && sjabloon.dataset.wagen) || '/cart';
  };

  const maakKaart = () => {
    if (kaart || !sjabloon) return kaart;
    kaart = sjabloon.content.firstElementChild.cloneNode(true);
    kaart.querySelectorAll('[data-wtg-bekijk]').forEach((k) => k.addEventListener('click', openWagen));
    kaart.querySelector('[data-wtg-sluit]').addEventListener('click', sluit);
    kaart.addEventListener('mouseenter', () => clearTimeout(verberg));
    kaart.addEventListener('mouseleave', () => { if (kaart.classList.contains('is-open')) plan(2500); });
    kaart.addEventListener('focusin', () => clearTimeout(verberg));
    document.body.appendChild(kaart);
    return kaart;
  };

  // Op de telefoon boven de meeschuivende koopbalk van de productpagina blijven
  const zetOnderkant = () => {
    if (!kaart) return;
    let hoogte = 0;
    document.querySelectorAll('.sticky-add-to-cart__bar').forEach((balk) => {
      const r = balk.getBoundingClientRect();
      if (r.height > 0 && r.top < window.innerHeight && r.bottom >= window.innerHeight - 2) {
        hoogte = Math.max(hoogte, window.innerHeight - r.top);
      }
    });
    kaart.style.setProperty('--wtg-onder', hoogte + 'px');
  };

  const toon = async (id, aantal, flesKnop) => {
    if (ladeOpen() || !sjabloon) return;
    let wagen;
    try {
      wagen = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    } catch (e) {
      return;
    }
    if (ladeOpen()) return;
    const regel = (wagen.items || []).find((i) => String(i.variant_id) === String(id)) || (wagen.items || [])[0];
    if (!regel) return;

    const k = maakKaart();
    const beeld = k.querySelector('[data-wtg-beeld]');
    if (regel.image) {
      beeld.src = regel.image + (regel.image.includes('?') ? '&' : '?') + 'width=120';
      beeld.alt = regel.product_title || '';
      beeld.parentElement.style.display = '';
    } else {
      beeld.parentElement.style.display = 'none';
    }
    k.querySelector('[data-wtg-naam]').textContent = regel.product_title || regel.title || '';
    const stuks = aantal || 1;
    // Fles of stuk: knop Fles/Doos, of een producttype dat een fles is (Wijn, Champagne, Port, Sake, ...)
    const soort = String(regel.product_type || '');
    const isFles = flesKnop ||
      (/(wijn|champagne|port|sake|cava|prosecco|cr[eé]mant|sherry|madeira)/i.test(soort) &&
        !/(pakket|klimaat|kast|accessoire|koeler|glas|bon|boek)/i.test(soort));
    const eenheid = isFles ? (stuks === 1 ? 'fles' : 'flessen') : (stuks === 1 ? 'stuk' : 'stuks');
    k.querySelector('[data-wtg-prijs]').textContent = stuks + ' ' + eenheid + ' · ' + euro((regel.final_price || regel.price || 0) * stuks);

    const totaal = wagen.total_price || 0;
    const rest = drempel - totaal;
    k.querySelector('[data-wtg-voortgang-tekst]').innerHTML =
      rest > 0 ? 'Nog <b>' + euro(rest) + '</b> tot gratis bezorging' : '<b>Je bestelling wordt gratis bezorgd</b>';
    const vulling = k.querySelector('[data-wtg-vulling]');
    vulling.style.width = '0%';

    zetOnderkant();
    k.classList.remove('is-open');
    void k.offsetWidth;
    k.classList.add('is-open');
    requestAnimationFrame(() => {
      vulling.style.width = Math.min(100, (totaal / drempel) * 100) + '%';
    });
    plan(ZICHTBAAR_MS);
  };

  document.addEventListener('cart:update', (event) => {
    const detail = event.detail || {};
    const data = detail.data || {};
    if (data.source !== 'instant-add-buttons-component' && data.source !== 'product-form-component') return;
    const id = String(detail.sourceId || '');
    const b = bezig.get(id) || [...bezig.values()].pop();
    if (b) {
      clearTimeout(b.timer);
      bezig.forEach((waarde, sleutel) => { if (waarde === b) bezig.delete(sleutel); });
    }
    if (data.didError) {
      knopTerug(b && b.knop);
      return;
    }
    knopKlaar(b && b.knop);
    toon(id, Number(data.itemCount) || 1, b ? b.flesKnop : true);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && kaart && kaart.classList.contains('is-open')) sluit();
  });
})();
